import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import PlatformServiceDeskPage from '@src/pages/Platform/ServiceDesk';

export const Route = createLazyFileRoute('/platform/service-desk')({
  component: PlatformServiceDeskPageWithLayout,
});

function PlatformServiceDeskPageWithLayout() {
  return (
    <DefaultLayout>
      <PlatformServiceDeskPage />
    </DefaultLayout>
  );
}
